import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { User } from '../../models/user';
import { ErrorService } from '../../services/error.service';
import { OrderService } from '../../services/order.service';
import { ParcelService } from '../../services/parcel.service';
import { SpinnerService } from '../../services/spinner.service';
import { SubscriptionService } from '../../services/subscription.service';
import { UserService } from '../../services/user.service';
import { ValidatorService } from '../../services/validator.service';
import { EmailShippingLabelData, EmailShippingLabelModalBaseComponent, ShippingLabelContext } from '../email-shipping-label-modal-base/email-shipping-label-modal-base.component';

@Component({
	selector: 'app-email-parcel-shipping-label-modal',
	templateUrl: '../email-shipping-label-modal-base/email-shipping-label-modal-base.component.html',
	styleUrls: ['../email-shipping-label-modal-base/email-shipping-label-modal-base.component.css']
})
export class EmailParcelShippingLabelModalComponent extends EmailShippingLabelModalBaseComponent {
	constructor(
		formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any,
		validatorService: ValidatorService,
		spinnerService: SpinnerService,
		errorService: ErrorService,
		orderService: OrderService,
		userService: UserService,
		subscriptionService: SubscriptionService,
		dialogRef: MatDialogRef<EmailParcelShippingLabelModalComponent>,
		private _parcelService: ParcelService
	) {
		super(formBuilder, data, validatorService, spinnerService, errorService, orderService, userService, subscriptionService, dialogRef);
	}

	protected get context(): ShippingLabelContext {
		return 'routeParcel';
	}

	protected get titleKey(): string {
		return 'emailShippingLabelView.titleSingular';
	}

	protected getDefaultLabelId(user: User): number | null | undefined {
		return user?.inetUser?.routeParcelShippingLabelId;
	}

	protected get failureLogLabel(): string {
		return 'emailParcelShippingLabels Failed';
	}

	protected performSend(emailData: EmailShippingLabelData, shippingLabelId: number): Observable<any> {
		return this._parcelService.emailParcelShippingLabels(this.data.parcelId, emailData, shippingLabelId);
	}
}
